import React, { useState, useEffect, useRef, useCallback, useContext } from "react";
import Imagemodal from "../ChildComponents/Imagemodal";
import MyContext from "../../../Inventory/MyContext";

const LogoBox = (props, { initialWidthPercent = 15, initialHeight = 100 }) => {
  const [imageModal, setImageModal] = useState(false);
  const [valueFromModal, setValueFromModal] = useState(null);
  const { droppedItems, setDroppedItems, stylesArray, handleStyleChange } = useContext(MyContext);

  const [dimensions, setDimensions] = useState({
    widthPercent: initialWidthPercent,
    minHeight: initialHeight,
    top: 0,
    left: 0,
  })
  console.log("dimensions", dimensions);

  const [position, setPosition] = useState({ x: 250, y: 50 });
  const [isDragging, setIsDragging] = useState(false);
  const [isResizing, setIsResizing] = useState(false);

  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });

  console.log("position", position);

  const [activeId, setActiveId] = useState('');
  const hasInitialized = useRef(false);
  const getId = props.keyValueId;

  useEffect(() => {
    if (!hasInitialized.current) {
      const item = droppedItems.find(item => item.id === props.keyValueId);
      const styleObject = stylesArray.find(item => item.id === props.keyValueId);
      if (item) {
        const parsedDimensions = parseTextContents(item.textContents);
        if (parsedDimensions) {

          if (styleObject && styleObject.style) {
            const width = styleObject.style["width"];
            const height = styleObject.style["height"];
            const widthValue = width ? parseFloat(width) : 0;
            const heightValue = height ? parseFloat(height) : 0;
            if (widthValue !== dimensions.widthPercent || heightValue !== dimensions.minHeight) {
              setDimensions({ widthPercent: widthValue, minHeight: heightValue, top: parsedDimensions.top, left: parsedDimensions.left });
            }
          }
        }
      }
      if (styleObject && styleObject.style) {
        const left = styleObject.style["left"];
        const top = styleObject.style["top"];
        const leftValue = left ? parseFloat(left) : 0;
        const topValue = top ? parseFloat(top) : 0;
        setPosition({ x: leftValue, y: topValue });
      }

      hasInitialized.current = true;
    }
  }, [props.keyValueId, droppedItems, stylesArray, dimensions]);

  const clickRef = useRef(null);
  const [isSelect, setIsSelect] = useState(false)

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (isSelect) {
        if (event.key === "ArrowUp") {
          // Prevent the default behavior of arrow keys
          event.preventDefault();

          // Move up by 1 pixel or 10 pixels if the Control key is pressed
          const moveAmount = event.ctrlKey ? 10 : 1;
          setPosition((prevPosition) => ({
            ...prevPosition,
            y: prevPosition.y - moveAmount,
          }));
        } else if (event.key === "ArrowDown") {
          event.preventDefault();
          // Move down by 1 pixel or 10 pixels if the Control key is pressed
          const moveAmount = event.ctrlKey ? 10 : 1;
          setPosition((prevPosition) => ({
            ...prevPosition,
            y: prevPosition.y + moveAmount,
          }));
        } else if (event.key === "ArrowLeft") {
          event.preventDefault();

          // Move left by 1 pixel or 10 pixels if the Control key is pressed
          const moveAmount = event.ctrlKey ? 10 : 1;
          setPosition((prevPosition) => ({
            ...prevPosition,
            x: prevPosition.x - moveAmount,
          }));
        } else if (event.key === "ArrowRight") {
          event.preventDefault();

          // Move right by 1 pixel or 10 pixels if the Control key is pressed
          const moveAmount = event.ctrlKey ? 10 : 1;
          setPosition((prevPosition) => ({
            ...prevPosition,
            x: prevPosition.x + moveAmount,
          }));
        }
      }
    };

    // Add the event listener when the component mounts
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      // Remove the event listener when the component unmounts
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isSelect]);


  const parseTextContents = (textContents) => {
    const regexDiv = /<div[^>]*class="[^"]*image-box resizable-web-template[^"]*"[^>]*style="([^"]*)"/;
    const divMatch = textContents.match(regexDiv);

    if (divMatch) {
      const styleText = divMatch[1];

      const widthMatch = styleText.match(/width:\s*(\d+)%/);
      const heightMatch = styleText.match(/height:\s*(\d+)px/);
      const topMatch = styleText.match(/top:\s*(\d+)px/);
      const leftMatch = styleText.match(/left:\s*(\d+)px/);

      //if (widthMatch && heightMatch && topMatch && leftMatch) {
      return {
        widthPercent: parseFloat(widthMatch ? widthMatch[1] : 0),
        minHeight: `${parseFloat(heightMatch ? heightMatch[1] : 0)}px`,
        top: parseFloat(topMatch ? topMatch[1] : 0),
        left: parseFloat(leftMatch ? leftMatch[1] : 0),
      };
    }
    //}
    return null;
  };

  const handleMouseDownForDragging = (e) => {
    if (e.button === 0) { // Left click for dragging
      const { clientX, clientY } = e;
      setIsDragging(true);
      setDragOffset({
        x: clientX - position.x,
        y: clientY - position.y,
      });
      e.preventDefault();
    }
  };

  // Function to handle mouse move for dragging
  const handleMouseMoveForDragging = (e) => {
    if (isDragging) {
      const { clientX, clientY } = e;
      setPosition({
        x: clientX - dragOffset.x,
        y: clientY - dragOffset.y,
      });
    }
  };

  // Handle mouse up to stop dragging
  const handleMouseUpForDragging = () => {
    setIsDragging(false);
    console.log(`left ${(position.x) / 15}`)
    console.log(`top ${position.y}`)
    console.log(`props.keyValueId ${props.keyValueId}`)
    handleStyleChange("left", `${position.x}`, "", props.keyValueId);
    handleStyleChange("top", `${position.y}`, "", props.keyValueId);
  };

  const handleMouseDown = useCallback((e, direction) => {
    if (e.button === 2) { // Right click for resizing
      e.preventDefault();
      const originalWidthPercent = dimensions.widthPercent;
      const originalHeight = parseFloat(dimensions.minHeight);
      const originalMouseX = e.pageX;
      const originalMouseY = e.pageY;
      const container = document.getElementById(props.keyValueId);
      const containerWidth = container.offsetWidth; // Get container width in pixels

      const onMouseMove = (e) => {
        let newWidthPercent = originalWidthPercent;
        let newHeight = originalHeight;
        const deltaX = e.pageX - originalMouseX;
        const deltaY = e.pageY - originalMouseY;

        if (direction === 'right') {
          const newWidth = (originalWidthPercent / 100 * containerWidth) + deltaX;
          newWidthPercent = (newWidth / containerWidth) * 100;
        } else if (direction === 'left') {
          const newWidth = (originalWidthPercent / 100 * containerWidth) - deltaX;
          newWidthPercent = (newWidth / containerWidth) * 100;
        } else if (direction === 'top') {
          newHeight = originalHeight - deltaY;
        } else if (direction === 'bottom') {
          newHeight = originalHeight + deltaY;
        }

        // Update dimensions with new values
        if (newWidthPercent > 5) setDimensions(prev => ({ ...prev, widthPercent: newWidthPercent }));
        if (newHeight > 40) setDimensions(prev => ({ ...prev, minHeight: newHeight }));

        // Update droppedItems with new dimensions
        if (props.keyValueId) {
          handleStyleChange("width", `${newWidthPercent}`, "%", props.keyValueId);
          handleStyleChange("height", `${newHeight}`, "px", props.keyValueId);
        }
      };

      const onMouseUp = () => {
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
      };

      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    }
  }, [dimensions, props.keyValueId]);

  const outlinebluemain = (e) => {
    const element = e.target.closest('.resizable-web-template');
    if (element) {
      const clickedId = element.id;
      setActiveId(prevId => {
        const deleteButton = document.getElementById(clickedId + "delete");
        if (deleteButton) {
          deleteButton.classList.toggle("column-one-delete-web-template");
        }
        const resizers = document.getElementsByClassName(clickedId);
        let isAnyDisplayed = false;

        if (resizers.length > 0) {
          for (let i = 0; i < resizers.length; i++) {
            resizers[i].classList.toggle("displayblock");

            // Check if it now contains the class after toggle
            if (resizers[i].classList.contains("displayblock")) {
              isAnyDisplayed = true;
            }
          }
          setIsSelect(isAnyDisplayed);
        } else {
          setIsSelect(false);
        }
        const EditButton = document.getElementById(clickedId + "EditImage");
        if (EditButton.style.opacity) {
          if (EditButton.style.opacity === "0") {
            EditButton.style.opacity = "1";
          } else {
            EditButton.style.opacity = "0";
          }
        }
        else {
          EditButton.style.opacity = "1";
          console.log("value is blank");
        }
        return prevId === clickedId ? '' : clickedId;
      });
    }
  };

  const handleDropItem = (e) => {
    setImageModal(true);
    e.stopPropagation();
    const deleteButton = document.getElementById(getId + "delete");
    if (deleteButton) {
      deleteButton.classList.toggle("column-one-delete-web-template");
    }
  };

  const openimagemodal = (e) => {
    e.stopPropagation();
    setImageModal(!imageModal);
  };

  const handleValueFromModal = (value) => {
    setValueFromModal(value);
  };

  useEffect(() => {
    const handleMouseUp = () => {
      setIsDragging(false);
      setIsResizing(false);
    }

    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {

      const element = document.getElementById(props.keyValueId);
      if (!element) return;

      const isImageBox = element.classList.contains('image-box');

      // Resize image box if shift is held
      if (event.altKey && isImageBox) {
        event.preventDefault();
        const resizeAmount = event.ctrlKey ? 10 : 5;

        if (event.key === 'ArrowUp') {
          setDimensions((prev) => {
            const newHeight = prev.minHeight - resizeAmount;
            handleStyleChange("height", `${newHeight}`, "px", props.keyValueId);
            return {
              ...prev,
              minHeight: newHeight,
            };
          });
        } else if (event.key === 'ArrowDown') {
          setDimensions((prev) => {
            const newHeight = prev.minHeight + resizeAmount;
            handleStyleChange("height", `${newHeight}`, "px", props.keyValueId);
            return {
              ...prev,
              minHeight: newHeight,
            };
          });
        } else if (event.key === 'ArrowLeft') {
          setDimensions((prev) => {
            const newWidth = Math.max(5, prev.widthPercent - resizeAmount);
            handleStyleChange("width", `${newWidth}`, "%", props.keyValueId);
            return {
              ...prev,
              widthPercent: newWidth,
            };
          });
        } else if (event.key === 'ArrowRight') {
          setDimensions((prev) => {
            const newWidth = Math.min(100, prev.widthPercent + resizeAmount);
            handleStyleChange("width", `${newWidth}`, "%", props.keyValueId);
            return {
              ...prev,
              widthPercent: newWidth,
            };
          });
        }
        return;
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [dimensions]);


  return (
    <div className="image-box resizable-web-template"
      style={{
        backgroundSize: "100% 100%",
        margin: "8px auto",
        // backgroundRepeat: "no-repeat",
        width: `${dimensions.widthPercent}%`,
        minHeight: dimensions.minHeight,
        position: "absolute", //'inherit'
        left: `${(position.x) / 15}%`,
        top: (position.y),
        // left: (position.x == 250 ? dimensions.left : position.x), // Control the horizontal movement
        // top: (position.y == 50 ? dimensions.top : position.y),  // Control the vertical movement
        cursor: isDragging ? "grabbing" : "grab",
        zIndex: "5"
      }}
      onMouseDown={handleMouseDownForDragging}
      onMouseMove={handleMouseMoveForDragging}
      onMouseUp={handleMouseUpForDragging}
      onDragStart={props.handleDrag}
      onDrop={props.handleDrop}
      onDragOver={props.dragover}
      draggable="true"
      id={getId}
      onClick={outlinebluemain}
      ref={clickRef}
    >
      <div className="resizers-web-template" style={{ minHeight: dimensions.minHeight, }} >
        <div className={`resizer-web-template ${props.keyValueId} top-web-template `} onMouseDown={(e) => handleMouseDown(e, 'top')}></div>
        <div className={`resizer-web-template ${props.keyValueId} right-web-template `} onMouseDown={(e) => handleMouseDown(e, 'right')}></div>
        <div className={`resizer-web-template ${props.keyValueId} bottom-web-template `} onMouseDown={(e) => handleMouseDown(e, 'bottom')}></div>
        <div className={`resizer-web-template ${props.keyValueId} left-web-template `} onMouseDown={(e) => handleMouseDown(e, 'left')}></div>

        <i className="fa-solid fa-pen-to-square editimagebutton-web-template" id={props.keyValueId + "EditImage"} style={{ margin: "10px 12px", fontSize: "16px" }} onClick={handleDropItem}></i>
        {imageModal && (
          <Imagemodal
            handleclick={openimagemodal}
            passValueToParent={handleValueFromModal}
            getId={getId}
          />
        )}
      </div>
    </div>
  );
};

export default LogoBox;











// import { useEffect, useRef, useState } from "react";

// const LogoModal = (props) => {

//     const [imageUrl, setImageUrl] = useState([]);
//     const [, setLocalStrUrl] = useState("");
//     const [urlInput, setUrlInput] = useState("");
//     const [newImagesAdded, setNewImagesAdded] = useState(false); // New state to track if new images are added
//     // const [imageModal, setImageModal] = useState(true)
//     const inputRef = useRef(null);
//     // const valuChange = useRef(null);
  
//     // document.getElementById("body").style.;
  
  
//     const addImage = () => {
//       inputRef.current.click();
//     };
  
//     const handleImageUpload = (e) => {
//       const file = e.target.files[0];
//       console.log(file);
//       // if(file){
//       // const formData = new FormData();
//       // formData.append('file', file);
  
//       // // Replace 'uploadEndpoint' with the actual URL of your server's upload endpoint
//       // axios.post('http://localhost:3000/upload', formData)
//       //   .then((response) => {
//       //     // Handle the response from the server after successful upload
//       //     console.log('File uploaded successfully:', response.data);
//       //   })
//       //   .catch((error) => {
//       //     // Handle errors if the upload fails
//       //     console.error('Error uploading file:', error);
//       //   });
//     // }
//       if (file) {
//         const imageURL = URL.createObjectURL(file); 
//         setImageUrl((prevUrls) => [...prevUrls, imageURL]);
//         setLocalStrUrl(imageURL);
//         setNewImagesAdded(true); // Set the flag to indicate new images are added
//       }
//     };
  
//     const handleAddImageFromUrl = () => {
//       setImageUrl((prevUrls) => [...prevUrls, urlInput]);
//       setLocalStrUrl(urlInput);
//       setNewImagesAdded(true); // Set the flag to indicate new images are added
//     };
  
//     useEffect(() => {
//       // Update localStorage only if new images are added
//       if (newImagesAdded) {
//         localStorage.setItem("imageURL", JSON.stringify(imageUrl));
//         setNewImagesAdded(false); // Reset the flag after updating localStorage
//       }
//     }, [imageUrl, newImagesAdded]);
  
//     useEffect(() => {
//       const savedImageUrl = JSON.parse(localStorage.getItem("imageURL"));
//       if (savedImageUrl) {
//         setImageUrl(savedImageUrl);
//         setLocalStrUrl(savedImageUrl[0]); // Assuming you want to display the first image in the localStrUrl state
//       }
//     }, []);
  
//     const handleInputChange = (e) => {
//       setUrlInput(e.target.value);
//     };
  
//     const handleValuePassing = (localValue) => {
      
//       console.log("image open")
//       props.passValueToParent(localValue);
    
      
//     };
//     const handleValuePassing1  =()=>{
//       props.passValueToParent1("false");
//     }
  
//     return (
//       <div>
//         <div className="modal-back">
//           <div className="image-modal">
//             <div className="viewcode-modal-heading">Logo-selector-box</div>
//             <i 
//               id="modal_box_close"
//               onClick={props.handleclick}
//               className="fa-sharp fa-solid fa-xmark"
//             ></i>
//             <div className="image-modal-main">
//               <div className="image-modal-left" onClick={addImage}>
//                 {/* <div className="image-left-heading"><p>HTML</p></div> */}
//                 <p className="upload-image-txt">
//                   Drop file here or click to upload
//                 </p>
//                 <input type="file" style={{display:"none"}} ref={inputRef} onChange={handleImageUpload}/>
//               </div>
//               <div className="image-modal-right">
//                 <div className="image-modal-rignt-top">
//                   <div><input className="add-image-input" type="text" placeholder="Enter URL" value={urlInput}
//                     onChange={handleInputChange}/></div>
//                   <div><button className="add-image-btn" onClick={handleAddImageFromUrl} >Add Image</button></div>
//                   {/* <div><button className="add-image-btn" onClick={handleValuePassing} style={{display:"none"}}></button></div> */}
//                 </div>
//                 <div className="image-modal-right-bottom">
//                   { imageUrl.map((localValue,index) =>(
//                   <div className="right-bottom-box" key={index}>
//                     <div onClick={handleValuePassing1}><img src={localValue} alt="" style={{width:"200px",height:"100px",objectFit:"cover"}}onClick={() => handleValuePassing(localValue)}/> </div>
//                     <div><p></p></div>
//                   </div>
//                   ))
//   }
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };
  
  

// export default LogoModal;
